import { createAction } from '@reduxjs/toolkit';

import type { PopupDataState } from './types';
import { name } from './slice';

export const toggleMap = createAction(`${name}/toggleMap`);

/**
 * эти два экшена использовались в старой карте
 * TODO: убарть с выпилом старой карты
 */
export const fetchHotelDataActions = createAction(`${name}/fetchHotelData`);
export const hotelDataFetched = createAction(`${name}/hotelataFetched`);

export const setPopupData = createAction<PopupDataState>(
  `${name}/setPopupData`,
);

export const resetPopupData = createAction(`${name}/resetPopupData`);
